export function createProductLocationKey(...rest) {
  return rest.join("_");
}
